export default __webpack_public_path__ + "00f039f41732a26e33e319877e0e2608.png";